// Public pages served by the Next app (web/). nginx sends a full page load of
// these paths to Next; inside the SPA, a click on a link to one of them has to
// leave react-router and load the page again, or the old SPA version shows up.
//
// Keep in sync with the location regex in sporexpertweb/nginx/nginx.prod.conf.
//
// Off unless the build sets REACT_APP_NEXT_PUBLIC_ROUTES=true (scripts/build.sh
// does). Without Next in front (npm start, stage), the SPA keeps its own pages;
// turning this on there would reload the same URL forever.
export const NEXT_PUBLIC_ROUTES = process.env.REACT_APP_NEXT_PUBLIC_ROUTES === 'true';

const NEXT_ROUTE =
  /^\/(es|en)(\/|\/blog|\/blog\/post\/[^/]+|\/shop|\/shop\/products\/[^/]+|\/about-us|\/faqs|\/contact-us|\/privacy|\/terms|\/mycolab|\/tools|\/tools\/(calc|tincture-calc)|\/tools\/(wood-guide|contamination-guide|cultivation-recipes)(\/[^/]+)?)?\/?$/;

// Guía de hongos (location propia en nginx.prod.conf).
const SPECIES_ROUTE = /^\/(es|en)\/(hongos|mushrooms)(\/[a-z0-9-]+)?\/?$/;

export function isNextRoute(path) {
  if (!NEXT_PUBLIC_ROUTES || typeof path !== 'string') return false;
  const clean = path.split(/[?#]/)[0];
  return NEXT_ROUTE.test(clean) || SPECIES_ROUTE.test(clean);
}
